"use client";

import React, { createContext, useContext, useState, ReactNode } from "react";

type ToastAction = {
  name: string;
  payload?: any;
  timestamp: number;
} | null;

interface ToastActionContextProps {
  action: ToastAction;
  dispatchToastAction: (name: string, payload?: any) => void;
  clearToastAction: () => void;
}

const ToastActionContext = createContext<ToastActionContextProps | undefined>(undefined);

export const ToastActionProvider = ({ children }: { children: ReactNode }) => {
  const [action, setAction] = useState<ToastAction>(null);

  const dispatchToastAction = (name: string, payload?: any) => {
    setAction({ name, payload, timestamp: Date.now() });
  };

  const clearToastAction = () => {
    setAction(null);
  };

  return (
    <ToastActionContext.Provider value={{ action, dispatchToastAction, clearToastAction }}>
      {children}
    </ToastActionContext.Provider>
  );
};

export function useToastAction() {
  const context = useContext(ToastActionContext);
  if (!context) {
    throw new Error("useToastAction must be used within a ToastActionProvider");
  }
  return context;
}